"use client";

import { Button, Stack } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useRouter } from "@/i18n/routing";
import { useTranslations } from "next-intl";

const ACCENT = "#F15859";

export default function WelcomeSectionButtons() {
    const router = useRouter();

    const onGotoSection = (section: string) => {
        if (section === "#home-plan-section") {
            router.push(`/#home-plan-section`);
        } else {
            router.push(`/service/${section}`);
        }
    };

    const t = useTranslations('HomePage.welcome_section');

    return (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                    bgcolor: ACCENT,
                    fontWeight: 700,
                    px: 4,
                    py: 1.6,
                    textTransform: "none",
                    "&:hover": { bgcolor: "#F15859" },
                }}
                href="/contact"
            >
                {t('button_1')}
            </Button>

            <Button
                variant="outlined"
                size="large"
                sx={{
                    borderColor: "rgba(255,255,255,0.3)",
                    color: "white",
                    textTransform: "none",
                }}
                onClick={() => onGotoSection("#home-plan-section")}
            >
                {t('button_2')}
            </Button>

            <Button
                variant="outlined"
                size="large"
                sx={{
                    borderColor: "rgba(255,255,255,0.3)",
                    color: "white",
                    textTransform: "none",
                }}
                onClick={() => onGotoSection("#services-section")}
            >
                {t('button_3')}
            </Button>
        </Stack>
    );
}
